var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mainLayoutType === 'horizontal' && _vm.windowWidth >= 1200)?[(_vm.currentUser.id != null)?[_c('h-nav-menu',{class:[
                    { 'text-white': _vm.isNavbarDark && !_vm.isThemeDark },
                    { 'text-base': !_vm.isNavbarDark && _vm.isThemeDark }
                ]})]:_vm._e()]:[(_vm.currentUser.id != null)?[_c('the-navbar-vertical',{class:[
                    { 'text-white': _vm.isNavbarDark && !_vm.isThemeDark },
                    { 'text-base': !_vm.isNavbarDark && _vm.isThemeDark }
                ],attrs:{"navbarColor":_vm.navbarColor}}),_c('v-nav-menu',{class:[
                    { 'text-white': _vm.isNavbarDark && !_vm.isThemeDark },
                    { 'text-base': !_vm.isNavbarDark && _vm.isThemeDark }
                ]})]:_vm._e()],_c('wellful-logo')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }